import React, { useState, useEffect, useMemo } from "react";
import { Box, Menu, MenuItem, ListItemIcon } from "@mui/material";
import { styled, useTheme } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";
import { useSelector } from "react-redux";
import Tooltip from "@mui/material/Tooltip";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import Button from "@mui/material/Button";
import Breadcrumbs from "../common/breadcrumbs";
import DevicesService from "../api/devices";
import CommonDateTimePicker from "../common/commonDateTimePicker";
import DashboardsService from "../api/dashboards";
import {
  GetDateTimeStringToday,
  GetDateTimeString7DaysAgo,
  getUrlVars,
  GetMachineTypeIcon,
} from "../utils/systemInfo";
import { UserPermissionConstants } from "../utils/permissions";
import utils from "../utils/utils";
import DashboardsListMenu from "../common/dashboardsListMenu";
import { useLocation, useNavigate } from "react-router-dom";

const breadcrumbs = [
  { id: 0, name: "Home", href: "./" },
  { id: 1, name: "Dashboards", href: "dashboards" },
];
const StyleMachineSpan = styled((props) => <span {...props} />)(
  ({ theme }) => ({
    color: theme.palette.custom.text,
  })
);
const StyledMenu = styled((props) => <Menu {...props} />)(({ theme }) => ({
  "& .MuiPaper-root": {
    backgroundColor: theme.palette.secondary.dark,
    color: theme.palette.custom.light,
  },
}));
const StyledButton = styled((props) => <Button {...props} />)(({ theme }) => ({
  height: "36px",
  backgroundColor: theme.palette.custom.buttonColor,
  color: theme.palette.custom.buttonTextColor,
  "&:hover": {
    backgroundColor: theme.palette.custom.buttonHoverColor,
    color: theme.palette.custom.buttonHoverTextColor,
    boxShadow: "none",
  },
  width: "fit-content",
}));

function Dashboard() {
  const theme = useTheme();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const organziation = useSelector(({ organziation }) => organziation);
  const permissions = useSelector(({ permissions }) => permissions);
  const [machineDeviceName, setMachineDeviceName] = useState("Fleet");
  const [machineDeviceArray, setMachineDeviceArray] = useState(["Fleet"]);
  const [anchorMachine, setAnchorMachine] = useState(null);
  const [editGrafanaLink, setEditGrafanaLink] = useState(null);
  // const [loadingValue, setLoadingValue] = useState(true);
  const location = useLocation();

  useEffect(() => {
    const orgObj =
      organziation ?? JSON.parse(localStorage.getItem("defaultOrganization"));
    if (orgObj) {
      const apiKey = orgObj?.api_key_list?.[0]?.key;
      DashboardsService.getGrafanaDashboardOperationLink({
        grafana_dashboard_link_id: "",
        operation_profile_id: orgObj?.uid.toString(),
        grafana_dashboard_id: "",
        status: "",
        apiKey,
      })
        .then((json) => {
          if (
            !json?.grafana_dashboard_operation_link?.find(
              (x) =>
                x.grafana_dashboard_name_backend === getUrlVars()["Dashboard"]
            )
          ) {
            navigate("/");
          }
        })
        .catch((errorr) => {
          navigate("/");
          if (process.env.NODE_ENV === "development")
            console.log("errorr", errorr);
        });

      DevicesService.getDevices({
        deviceID: "",
        deviceType: [
          "nerohub",
          "nanohub",
          "cyberhub",
          "stratahub",
          "nerotrax",
          "train",
          "autonomous hub",
        ],
        apiKey,
        historyFromDST: GetDateTimeString7DaysAgo(),
        historyToDST: GetDateTimeStringToday(),
      })
        .then((json) => {
          if (json && json.device_profile && json.device_profile.length > 0) {
            let machineTypesArray = ["Fleet"];
            for (let index = 0; index < json.device_profile.length; index++) {
              if (
                machineTypesArray.indexOf(
                  json.device_profile[index].vehicle_type
                ) === -1
              ) {
                machineTypesArray.push(json.device_profile[index].vehicle_type);
              }
            }

            setMachineDeviceArray(machineTypesArray);
          }
        })
        .catch((errorr) => {
          if (process.env.NODE_ENV === "development")
            console.log("getUserTypePermissionserrorr", errorr);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const handleOpenMachineMenu = (event) => {
    setAnchorMachine(event.currentTarget);
  };
  const handleCloseMachineMenu = () => {
    setAnchorMachine(null);
  };
  const handleChooseMachine = (item) => {
    // setLoadingValue(true);
    setMachineDeviceName(item);
    setAnchorMachine(false);
    // setLoadingValue(false);
  };
  const handleBreadCrumbsArray = (breadcrumbs) => {
    // if (breadcrumbs.length === 3) {
    //     return breadcrumbs
    // }
    const Dashboard = getUrlVars()["Dashboard"];
    const deviceType = getUrlVars()["DeviceTitleDataName"];
    breadcrumbs[2] = {
      id: 2,
      name: Dashboard,
      href: `/dashboard?Dashboard=${Dashboard}&DeviceTitleDataName=${deviceType}&timerange`,
      noTranslation: true,
    };
    return breadcrumbs;
  };
  const handleUpdateGrafanaLink = (newUrl) => {
    const newGrafanaLink = newUrl
      .replaceAll(
        window.env.REACT_APP_GRAFANA_URL,
        window.env.REACT_APP_EDITGRAFANA_URL
      )
      .replaceAll("&kiosk=true&_dash.hideTimePicker&_dash.hideVariables", "");

    setEditGrafanaLink(newGrafanaLink);
  };
  function handleAssignEditDashboard() {
    window.open(editGrafanaLink, "_blank").focus();
  }
  return (
    <Box
      sx={{
        p: "12px",
        minHeight: `100%`,
        height: "100%",
      }}
    >
      <Box sx={{ width: "100%", height: { xs: "fit-content", sm: `88px` } }}>
        {useMemo(
          () => (
            <Breadcrumbs breadcrumbs={handleBreadCrumbsArray(breadcrumbs)} />
          ),
          // eslint-disable-next-line react-hooks/exhaustive-deps
          [location]
        )}

        <Box
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
            flexFlow: { xs: "column", sm: "row" },
            alignItems: "center",
            height: { xs: "fit-content", sm: "64px" },
          }}
        >
          <Box sx={{ display: { xs: "block", sm: "flex" } }}>
            {<DashboardsListMenu pageName={getUrlVars()["name"]} />}
          </Box>
          <Box
            sx={{
              float: "right",
              display: "flex",
              gap: "0.5rem",
              width: { xs: "100%", sm: "fit-content" },
            }}
          >
            {permissions &&
              utils.hasPermission(
                UserPermissionConstants.OPEN_DASHBOARD_LINK_IN_GRAFANA,
                permissions
              ) && (
                <>
                  <Tooltip title={t("OpenInGrafana")}>
                    <StyledButton
                      variant="contained"
                      onClick={handleAssignEditDashboard}
                    >
                      {t("EditDashboard")}
                    </StyledButton>
                  </Tooltip>
                </>
              )}
            <Tooltip title="Open settings">
              <Button
                variant="text"
                onClick={handleOpenMachineMenu}
                sx={{ height: "36px", float: "right", display: "flex" }}
                endIcon={
                  <KeyboardArrowDownIcon
                    sx={{
                      fontSize: "30px",
                      color: theme.palette.custom.text,
                    }}
                  />
                }
              >
                <StyleMachineSpan
                  sx={{
                    fontSize: { xs: "25px", sm: "30px" },
                  }}
                >
                  {machineDeviceName}
                </StyleMachineSpan>
              </Button>
            </Tooltip>
            <StyledMenu
              id="menu-appbar"
              anchorEl={anchorMachine}
              open={Boolean(anchorMachine)}
              onClose={handleCloseMachineMenu}
              keepMounted
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
            >
              {machineDeviceArray &&
                machineDeviceArray.map((item) => (
                  <MenuItem
                    key={item}
                    onClick={() => handleChooseMachine(item)}
                  >
                    <ListItemIcon>
                      {item !== "Fleet" && (
                        <div
                          style={{ width: "30px" }}
                          dangerouslySetInnerHTML={{
                            __html: GetMachineTypeIcon(item).replace(
                              "theme.palette.custom.text",
                              theme.palette.custom.text
                            ),
                          }}
                        />
                      )}
                    </ListItemIcon>
                    <Typography textAlign="center">
                      {item ? item : ""}
                    </Typography>
                  </MenuItem>
                ))}
            </StyledMenu>
          </Box>
        </Box>
      </Box>
      <Divider
        sx={{ my: "10px", backgroundColor: theme.palette.custom.borderColor }}
      />
      <Box
        sx={{
          height: { xs: "100%", sm: `calc(100% - 94px)` },
        }}
      >
        <CommonDateTimePicker
          machineDeviceName={machineDeviceName}
          handleUpdateGrafanaLink={handleUpdateGrafanaLink}
        />
      </Box>
    </Box>
  );
}

export default Dashboard;
